import React, { useState, useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import Table from "../../../Extracomponents/Table";
import Table1 from "../../../Extracomponents/Table1";
import { Tooltip } from "antd";
import {
    getplancartlist, getbasketcartlist
} from "../../../Services/Admin/Admin";
import {
    fDateTime,
} from "../../../../Utils/Date_formate";
import Content from "../../../components/Contents/Content";
import { Eye, Pencil, Trash2, IndianRupee } from 'lucide-react';
import ReusableModal from "../../../components/Models/ReusableModal";

const CartList = () => {


    const { id } = useParams();
    const token = localStorage?.getItem("token");

    const [data, setData] = useState([]);
    const [basketdata, setBasketdata] = useState([]);

    const [viewMode, setViewMode] = useState("plan");

    const [searchInput, setSearchInput] = useState("");
    const [showModal, setShowModal] = useState(false);
    const [viewpage, setViewpage] = useState({});


    useEffect(() => {
        plandetail()
        basketdetail()
    }, [searchInput])



    const plandetail = async () => {
        try {
            const response = await getplancartlist(id, token);

            if (response.status) {
                const filterdata = response?.data?.filter(
                    (item) =>
                        searchInput === "" ||
                        item?.plan_id?.category?.title.toLowerCase().includes(searchInput.toLowerCase()) ||
                        item?.plan_id?.validity?.toLowerCase().includes(searchInput.toLowerCase())

                );
                setData(searchInput ? filterdata : response?.data)
            }
        } catch (error) {
            console.error("Error fetching client details:", error);
        }
    };




    const basketdetail = async () => {
        try {
            const response = await getbasketcartlist(id, token);

            if (response.status) {
                const filterdata = response?.data?.filter(
                    (item) =>
                        searchInput === "" ||
                        item?.basket_id?.title?.toLowerCase().includes(searchInput.toLowerCase()) ||
                        item?.basket_id?.themename?.toLowerCase().includes(searchInput.toLowerCase()) ||
                        item?.basket_id?.validity?.toLowerCase().includes(searchInput.toLowerCase())

                );
                setBasketdata(searchInput ? filterdata : response?.data)
            }
        } catch (error) {
            console.error("Error fetching client details:", error);
        }
    };




    const columns = [
        {
            name: "S.No",
            selector: (row, index) => index + 1,
            width: "100px",
        },
        {
            name: "Name",
            selector: (row) => row?.plan_id?.category?.title
                || "-",
            width: "180px",
        },
        {
            name: "Amount",
            selector: (row) => row?.plan_id?.price ?? "-",
            width: "189px",
        },
        {
            name: "Validity",
            selector: (row) => row?.plan_id?.validity ?? "-",
            width: "180px",
        },
        {
            name: "Created At",
            selector: (row) => (row?.createdAt ? fDateTime(row?.createdAt) : ""),
            width: "180px",
        },
        {
            name: 'Actions',
            cell: row => {
                return (
                    <>
                        <div className='d-flex' >
                            <div >
                                <Tooltip placement="top" overlay="View">
                                    <Eye
                                        style={{ marginRight: "10px" }}

                                        onClick={() => { setShowModal(true); setViewpage(row?.plan_id?.description) }}
                                    />
                                </Tooltip>
                            </div>
                        </div>

                    </>
                );
            }
        }

    ];


    const columns1 = [
        {
            name: "S.No",
            selector: (row, index) => index + 1,
            width: "100px",
        },
        {
            name: "Name",
            selector: (row) => row?.basket_id?.title
                || "-",
            width: "180px",
        },
        {
            name: "Theme Name",
            selector: (row) => row?.basket_id?.themename
                || "-",
            width: "180px",
        },
        {
            name: "Amount",
            selector: (row) => row?.basket_id?.basket_price ?? "-",
            width: "189px",
        },
        {
            name: "Validity",
            selector: (row) => row?.basket_id?.validity ?? "-",
            width: "180px",
        },
        {
            name: "Created At",
            selector: (row) => (row?.createdAt ? fDateTime(row?.createdAt) : ""),
            width: "180px",
        },

    ];


    return (
        <div>
            <Content
                Page_title="Cart Detail"
                button_status={false}
                backbutton_status={true}
                backForword={true}
            >
                <div className="page-content">

                    <div className="card">
                        <div className="card-body">
                            <div className="d-flex justify-content-between mb-4">
                                <div className="btn-group">
                                    <button
                                        className={`btn btn-light ${viewMode === "plan" ? "active" : ""
                                            }`}
                                        onClick={() => setViewMode("plan")}
                                    >
                                        Plan
                                    </button>
                                    <button
                                        className={`btn btn-light ${viewMode === "basket" ? "active" : ""
                                            }`}
                                        onClick={() => setViewMode("basket")}
                                    >
                                        Basket
                                    </button>
                                </div>
                            </div>

                            {viewMode === "plan" ? (
                                <>
                                    <div className="d-lg-flex align-items-center mb-4 gap-3">
                                        <div className="position-relative">
                                            <input
                                                type="text"
                                                className="form-control ps-5 radius-10"
                                                placeholder="Search plan cart"
                                                value={searchInput}
                                                onChange={(e) => setSearchInput(e.target.value)}
                                            />
                                            <span className="position-absolute top-50 product-show translate-middle-y">
                                                <i className="bx bx-search" />
                                            </span>
                                        </div>

                                    </div>
                                    <Table columns={columns} data={data} />
                                </>

                            ) : (
                                <>
                                    <div className="d-lg-flex align-items-center mb-4 gap-3">
                                        <div className="position-relative">
                                            <input
                                                type="text"
                                                className="form-control ps-5 radius-10"
                                                placeholder="Search basket cart"
                                                value={searchInput}
                                                onChange={(e) => setSearchInput(e.target.value)}
                                            />
                                            <span className="position-absolute top-50 product-show translate-middle-y">
                                                <i className="bx bx-search" />
                                            </span>
                                        </div>

                                    </div>
                                    <Table columns={columns1} data={basketdata} />
                                </>
                            )}
                        </div>
                    </div>
                    <ReusableModal
                        show={showModal}
                        onClose={() => setShowModal(false)}
                        title={<span>Detail</span>}
                        body={<div dangerouslySetInnerHTML={{ __html: viewpage }} />}
                    />

                </div>
            </Content>
        </div>
    );
};

export default CartList;
